export default __webpack_public_path__ + "static/VNSGU-LOGO-f20234968f6055e0e73a2b49c97ef6fe.png";